import type { INavItem } from '@anywayseo/tools';

export type Locale = (typeof locales)[number];
export type Localized<T> = Record<Locale, T>;

export const REF_LINK = process.env.GATSBY_SITE_REF_LINK ?? 'https://slota.casino/de';

export const locales = ['de', 'en'] as const;

export const legalRoutes: Localized<INavItem[]> = {
  de: [
    { label: 'Datenschutzrichtlinie', path: '/datenschutzrichtlinie' },
    { label: 'Cookie-Richtlinie', path: '/cookie-richtlinie' },
    { label: 'Allgemeine Geschäftsbedingungen', path: '/allgemeine-geschaeftsbedingungen' },
    { label: 'Kontakt ', path: '/kontakt' },
  ],
  en: [
    { label: 'Privacy Policy', path: '/en/privacy-policy' },
    { label: 'Cookie Policy', path: '/en/cookie-policy' },
    { label: 'Terms and Conditions', path: '/en/terms-and-conditions' },
    { label: 'Contact', path: '/en/contacts' },
  ],
};

export { alternativeCasinos, type IAlternativeCasino } from './alternative-casinos';
